const defaults 	 = require('@/class/default_workspaces.js');
import helper 	from "@/helpers/helpers"
import Eventbus from "@/event-bus"
export const Workspaces = {
	namespaced: true,
  	state: {
  		list_workspaces  : {...defaults},
  		default  		 : {...defaults},
		// axios 			 : axios,
		// api 			 : api,
		// Eventbus  	  	 : eventbus,
		// bus  			 : {},
  	},
  	getters: { // get states 
  		state_workspace:(state)=> {
  			return state.list_workspaces;
  		},
  		list_options : (state)=>{
  			let array = Object.keys(state.list_workspaces)
			    .map(function(key) {
			        return state.list_workspaces[key];
			    });
			    // console.log("Array ", array)
			    array.unshift({
			    	manager_id 	: "all",
					name 		: "All",
				})
				/*array.push({
			    	manager_id 	: "test",
					name 		: "test",
				})*/
			return array; 
  		},
  	},
  	actions: { // asyncronous
  		add_to_workspaces({ commit }, new_state) {
  			commit('add_workspaces', new_state)
  		},
  		get_workspaces({commit}, info){
  			helper.get("/api/v1/workspace", "get").then(res => {
				// console.log("check_work request", res);
				if (res && res.data && res.data.rows && res.data.rows.length > 0) {
					let items = res.data.rows;
					if (items && items.length > 0) {
						
						items.forEach((wrk,idx_wrk)=>{
							if (wrk) {
								// console.log("test wrk ---- ", wrk)
								commit('add_workspaces', { ...wrk});
							}
						})
					}
				}
			}).catch(er =>{
				console.log("error req workspace", er);

			})
		
  		}
  	},
  	mutations: { // changes state
	    add_workspaces(state, msg) {

			let temp_manager =  "manager_id";
			// console.log("check_work msg **************** ", msg, msg[temp_manager], msg[temp_manager] == "", state.list_workspaces)
			// console.log("--------------------- ", state.list_workspaces)
			if (msg && msg[temp_manager]) {

				if (!state.list_workspaces[msg[temp_manager]]) {
					state.list_workspaces[msg[temp_manager]] = {... msg };
					if (msg.name) {
						state.list_workspaces[msg[temp_manager]].text = msg.name;
						state.list_workspaces[msg[temp_manager]].key  = msg.computer;

						/*if (msg.computer) {
							state.list_workspaces[msg[temp_manager]].text = msg.computer;
						}*/
					}else{
						if (msg[temp_manager] == 'my_computer') {
							state.list_workspaces[msg[temp_manager]].key 	= "my_computer";
							state.list_workspaces[msg[temp_manager]].text 	= "my_computer";
						}else{

							state.list_workspaces[msg[temp_manager]].key  = msg.computer;
							state.list_workspaces[msg[temp_manager]].text = msg.computer;
						}
					}

					for (let it in state.list_workspaces){
						if (it.sub_manager == msg[temp_manager]) {
							// console.warn("FINDED SUB MANAGER", msg[temp_manager]);
							it["sub_workspace_manager" + msg[temp_manager]] = state.list_workspaces[msg[temp_manager]]; 
						}
					}

					// this.Eventbus.$emit("update_workspace_dashboard", true);
				}else{
					
					state.list_workspaces[msg[temp_manager]] = { ...state.list_workspaces[msg[temp_manager]] , ...msg}  ;
					if (!state.list_workspaces[msg[temp_manager]].name) {
						if (msg.name) {
							state.list_workspaces[msg[temp_manager]].text = msg.name;
							state.list_workspaces[msg[temp_manager]].key  = msg.computer;
						}						
					}
					
				}
				// console.log("MOdified ", state.list_workspaces[msg[temp_manager]])
				
				Eventbus.$emit("states_workspace_" + msg[temp_manager], state.list_workspaces[msg[temp_manager]]);
			// }
			}
	    }, // add workspaces
	}, // mutations
/*
	create_workspace(manager = ""){
		return {
			key 	: manager,
			text 	: "",	
			manager : "",

				computer : "pc",
				color  	 : "primary",
				small  	 : false,
				large  	 : true,
				states 	 : {
					cpu : {
						is_percent 	: true,
						text 		: "cpu",
						percent 	: 50,
						icon  		: "mdi-thermostat-box",
					},
					ram : {
						is_percent 	: true,
						text 		: "ram",
						percent 	: 0, 
						icon  		: "mdi-thermostat-box",	
					},
					disk : { 
						is_percent 	: true,
						text 		: "disk",
						percent 	: 0, 
						icon  		: "mdi-thermostat-box",
					},
					devices : {			
						
					}
				}			
			
		};
	}
*/
}
